import {
    // SalesIndex,
    // SalesCreate,
    // SalesEdit,
    // SalesView,
    // PurchaseReturn,
    // BulkSale,
    PurchaseIndex,
    PurchaseCreate,
    PurchaseEdit,
    PurchaseView,
    SalesReturn,
    ReceivedCreate,
    ReceivedEdit,
    ReceivedIndex,
    ReceivedView,
    DailyCashEntry,
    DailyCash,
    PaymentCreate,
    PaymentEdit,
    PaymentIndex,
    PaymentView,
    RecipeIndex,
    RecipeCreate,
    RecipeEdit,
    RecipeView,
    RecipePurchase,
    AuditIndex,
    AuditAssets,
    JournalCompanyBillCreate,
    JournalCreate,
    JournalView,
    LedgerDetails,
    NoteSheet,
    JournalNoteSheet,
} from "../Components";

export default [
    {
        path: "/voucher/bq-store/purchase",
        component: PurchaseIndex,
        name: "voucher.bq.store.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/purchase/create",
        component: PurchaseCreate,
        name: "voucher.bq.store.purchase.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/sales-return/create",
        component: SalesReturn,
        name: "voucher.bq.store.sales.return.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/purchase/:id/edit",
        component: PurchaseEdit,
        name: "voucher.bq.store.purchase.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/purchase/:id/view",
        component: PurchaseView,
        name: "voucher.bq.store.purchase.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/daily-cash",
        component: DailyCash,
        name: "voucher.bq.store.daily.cash",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/daily-cash/entry",
        component: DailyCashEntry,
        name: "voucher.bq.store.daily.cash.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/received",
        component: ReceivedIndex,
        name: "voucher.bq.store.received",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/received/create",
        component: ReceivedCreate,
        name: "voucher.bq.store.received.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/received/:id/edit",
        component: ReceivedEdit,
        name: "voucher.bq.store.received.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/received/:id/view",
        component: ReceivedView,
        name: "voucher.bq.store.received.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/received/:id/note-sheet",
        component: NoteSheet,
        name: "voucher.bq.store.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/received/:id/journal-note-sheet",
        component: JournalNoteSheet,
        name: "voucher.bq.store.journal-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/payment",
        component: PaymentIndex,
        name: "voucher.bq.store.payment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/payment/create",
        component: PaymentCreate,
        name: "voucher.bq.store.payment.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/payment/:id/edit",
        component: PaymentEdit,
        name: "voucher.bq.store.payment.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/payment/:id/view",
        component: PaymentView,
        name: "voucher.bq.store.payment.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/journal/company-bill-create",
        component: JournalCompanyBillCreate,
        name: "voucher.bq.store.received.company.bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/journal/create",
        component: JournalCreate,
        name: "voucher.bq.store.journal.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/journal/:id/view",
        component: JournalView,
        name: "voucher.bq.store.journal.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/recipe",
        component: RecipeIndex,
        name: "recipe.bq.store.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/recipe/create",
        component: RecipeCreate,
        name: "recipe.bq.store.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/recipe/purchase/:id",
        component: RecipePurchase,
        name: "recipe.bq.store.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/recipe/:id/edit",
        component: RecipeEdit,
        name: "recipe.bq.store.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/recipe/:id/view",
        component: RecipeView,
        name: "recipe.bq.store.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/audit/bq-store/stock",
        component: AuditIndex,
        name: "audit.bq.store.stock",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/audit/bq-store/assets",
        component: AuditAssets,
        name: "audit.bq.store.assets",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bq-store/audit-ledger/update",
        component: LedgerDetails,
        name: "bq-store.audit.ledger.update",
        meta: {
            requiresAuth: true,
        },
    },
];
